import { render, staticRenderFns } from "./PeriodSelector.vue?vue&type=template&id=5fc48f00&scoped=true&"
import script from "./PeriodSelector.vue?vue&type=script&lang=js&"
export * from "./PeriodSelector.vue?vue&type=script&lang=js&"
import style0 from "./PeriodSelector.vue?vue&type=style&index=0&id=5fc48f00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc48f00",
  null
  
)

export default component.exports